import * as z from "zod";
import { create } from "zustand";

import { getItem, setItem } from "../services/local-storage";
import { View, viewSchema } from "../types/view";

const storedViewSchema = viewSchema.pick({ code: true, name: true });

export type StoredView = Required<Pick<View, "code" | "name">>;

const key = "views";
const maxViews = 10;

export const useViews = create<{
  views: StoredView[];
  addOrUpdateView: (view: StoredView) => void;
  deleteView: (code: string) => void;
  clearViews: () => void;
}>((set, get) => {
  return {
    views: getItem<StoredView[]>(key, z.array(storedViewSchema), []),
    addOrUpdateView: (view: StoredView) => {
      const updatedViews = [
        view,
        ...get().views.filter((storedView) => storedView.code !== view.code),
      ].slice(0, maxViews);

      set({ views: updatedViews });
      setItem(key, updatedViews);
    },
    deleteView: (code: string) => {
      const updatedViews = get().views.filter(
        (storedView) => storedView.code !== code,
      );

      set({ views: updatedViews });
      setItem(key, updatedViews);
    },
    clearViews: () => {
      set({ views: [] });
      setItem(key, []);
    },
  };
});
